import isPresent from 'is-present'
import isBlank from 'is-blank'
import I18n from './i18n'
import moment from "moment-timezone";
import { mapGetters } from 'vuex'
import { localize,} from 'vee-validate';
import LogoDefault from 'images/organization/logo-default.png'

const TRUE_VALUES=[true, 1, '1', 't', 'T', 'true', 'TRUE', 'on', 'ON', 'yes', 'YES', 'Yes']

export default {
  data (){
    return {
      FlashMessage: [],
      TRUE_VALUES
    }
  },
  methods: {
    to_a(val){
      return Array.isArray(val) ? val : [val]
    },
    external_links(text){
      // text = text.replace(/(<a)[^<]+<\/a>/gi, match => {
      //   if (match[/target=['"]_blank['"]/]) {
      //     return match
      //   } else {
      //     return match.replace(/(<a)/, "<a target=\"_blank\"")
      //   }
      // })
      // return text
      return text.replace(/<a[^<]/ig, '<a target="_blank" ')
    },
    isPresent(o){
      return isPresent(o)
    },
    isBlank(o){
      return isBlank(o)
    },
    get_locale(){
      return this.$route.params.locale ? ('/' + this.$route.params.locale) : ''
    },
    t(str, opts={}){
      this.$root.$children[0].translations //hack to make lazy load reactive
      return I18n.t(str,opts)
    },
    l(str, opts={}){
      this.$root.$children[0].translations //hack to make lazy load reactive
      return I18n.toTime(opts.format,str)
    },
    to_br(str){
      if (!str) return ""
      else return str.replace(/\r?\n/g, "<br>")
    },
    number_to_currency(value, curr = "$", precision=2){
      let number = parseFloat(value)
      if (isNaN(number)) number = 0

      const replace = /(\d)(?=(\d{3})+(?!\d))/g
      let str_number = number.toFixed(precision)
      let result;

      switch (curr) {
        case "%":
          if (number < 0) {
            number *= -1
            result = '- ' + parseFloat(number).toPrecision() + curr
          } else {
            result = parseFloat(str_number).toPrecision() + curr
          }
          break;
        case "$":
          if (number < 0) {
            str_number = str_number.replace(/^-/, '')
            result = '- ' + '$' + str_number.replace(replace, '$1,')
          } else {
            result = '$' + str_number.replace(replace, '$1,')
          }
          break;
        default:
          result = ""
      }

      return result
    },
    titleize(str){
      return str.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
    },
    humanize(str) {
      return str.trim().split(/\s+/).map(function(str) {
        return str.replace(/_/g, ' ').replace(/\s+/, ' ').trim()
      }).join(' ').toLowerCase().replace(/^./, function(m) {
        return m.toUpperCase()
      })
    },
    from_unix(unix,format="MM/DD/YYYY HH:mm"){
      if (!unix) return ''
      return moment.unix(unix).tz(window.time_zone).format(format)
    },
    time_from(str,format="MM/DD/YYYY HH:mm"){
      return moment(str).tz("UTC").format(format)
    },
    time_from_zone(str,format="MM/DD/YYYY HH:mm"){
      if (str !== undefined && window.time_zone !== undefined){
        return moment(str).tz(window.time_zone).format(format)
      } else { return "" }
    },
    markUnsavedChanges(){
      if (!window.vue_unsaved_changes) FamilyID.Views.UnsavedChangesAlert.init()
      window.vue_unsaved_changes = true
    },
    get_action(){
      return window.location.pathname.split('/').filter(str => { return str !== '' }).slice(-1)[0]
    },
    prepare_translation(obj, empty_data){
      if (!obj.translations[this.translate_to]) this.$set(obj.translations, this.translate_to, JSON.parse(JSON.stringify(empty_data)))

    },
    translation_changed(obj, field){
      if(obj.translations && obj.translations['en'] && obj.translations['en'][field] !== obj[field]){
        return 'CHANGED'
      }
    },
    clone_obj(obj){
      return JSON.parse(JSON.stringify(obj))
    },
    getImg(obj, size){
      if (obj){
        if (obj[size] && obj[size].url){
          return obj[size].url
        } else{
          return obj.url
        }
      } else{
        return LogoDefault
      }
    },
    has_account_access(rule){
      if(!this.current_user.id) return false
      if(this.current_user.id === this.current_account.user_id) return true
      return this.current_user.account_access.acl[rule]
    },

    has_organization_access(rule){
      if(!this.current_user.id) return false
      if(this.current_user.id === this.current_org.user_id) return true
      return this.current_user.access.acl[rule]
    },
    has_any_organization_access(rules){
      if(!this.current_user.id) return false
      if(this.current_user.id === this.current_org.user_id) return true
      for(const rule of rules){
        if (this.current_user.access.acl[rule]) return true
      }
      return false
    },
    student_transfer_org(){
      return this.current_org.student_transfer
    },
    capitalize(val){
      if (val){ return val.charAt(0).toUpperCase() + val.slice(1)}
    },
    showFlash(type, message){
      let obj = {}
      obj[type] = message
      FamilyID.Views.FlashMessage.showMessages(obj)
    },
    loadTranslations(){
      const locale = I18n.locale || I18n.default_locale
      const loc = "fid_i18n_" + locale
      this.axios.get('/api/config/i18n?locale=' + locale).then((response)=> {
        this.translations=I18n.translations = response.data
        window.localStorage.setItem(loc, JSON.stringify(response.data))
      })

      if (window.localStorage.getItem(loc)){
        this.translations=I18n.translations = JSON.parse(window.localStorage.getItem(loc))
      }
      // for vee-validate
      let vee_locale = locale
      if (vee_locale === "zh") vee_locale = "zh_CN"
      else if (vee_locale === "pt") vee_locale = "pt_PT"

      if (vee_locale === "so") import(`code/so.json`).then(this.applyVeeConfig)
      else import(`vee-validate/dist/locale/${vee_locale}.json`).then((res) =>{localize(I18n.locale, res)})
    },
    org_path(inc=''){
      if (typeof inc === 'string'){
        return this.org_id ? `/organizations/${this.org_id}${inc}` : inc
      }else{
        if (this.org_id){
          return {name: `Org${inc.name}`, params: {...this.$route.params, organization_id: this.org_id}}
        }else{
          return inc
        }
      }
    },
    simplePluralize(count, noun, suffix = 's'){
      return `${count} ${noun}${count !== 1 ? suffix : ''}`
    },
    display_responce_errors(errors){
      let errors_arr = []
      Object.keys(errors).forEach(key=>{
        errors_arr.push(key.charAt(0).toUpperCase() + key.slice(1) + " " + errors[key])
      })
      this.showFlash('error', errors_arr.join(', '))
    },
    async openLink(e, url) {
      e.stopPropagation();
      try {
        const resp = (await this.axios.post(`/api2/family/urls/bulk_sign`, { urls: [url] })).data;
        const fileUrl = resp[url];
        const proxyUrl = `/files/fetch_file?url=${encodeURIComponent(fileUrl)}`;
        const fileName = fileUrl.split('/').pop();
        const fileExtension = fileName.split('.').pop().split('?')[0].toLowerCase(); // Get the extension without query parameters
        
        const newWindow = window.open();
    
        if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff'].includes(fileExtension)) {
          newWindow.document.write(`
            <html>
              <head>
                <title>Image Viewer</title>
                <style>
                  body, html {
                    margin: 0;
                    padding: 0;
                    height: 100%;
                    width: 100%;
                    overflow: auto; /* Enable scrolling */
                  }
                  img {
                    width: 100%; /* Fit horizontally */
                    height: auto; /* Maintain aspect ratio */
                    display: block; /* Remove extra space below image */
                  }
                </style>
              </head>
              <body>
                <img src="${proxyUrl}" alt="Image" />
              </body>
            </html>
          `);
        } else if (fileExtension === 'pdf') {
          newWindow.document.write(`
            <html>
              <head>
                <title>PDF Viewer</title>
                <style>
                  body, html {
                    margin: 0;
                    padding: 0;
                    height: 100%;
                    width: 100%;
                    overflow: hidden; /* Prevent scrollbars */
                  }
                  iframe {
                    width: 100%;
                    height: 100%;
                    border: none; /* Remove border */
                  }
                </style>
              </head>
              <body>
                <iframe src="${proxyUrl}" frameborder="0"></iframe>
              </body>
            </html>
          `);
        } else {
          console.error("Unsupported file type:", fileExtension);
          alert("This file type is not supported for preview.");
        }
        newWindow.document.close();
      } catch (error) {
        console.error("Error fetching file:", error);
        alert("An error occurred while fetching the file. Please try again.");
      }
    }
  },
  computed: {
    ...mapGetters(['current_user', 'current_org', 'current_account']),
    translate_to(){return this.$route.query.translate_to || 'es'},
    route (){ return this.$route.params },
    state (){ return this.$store.state },
    org_id(){
      return this.$route.params.organization_id ?
        this.$route.params.organization_id :
        this.current_org.id
    },
    is_mobile(){
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
  },
  // This will be executed before leaving each route. If window.vue_unsaved_changes is set to true, then this will trigger an alert modal.
  beforeRouteUpdate (to, from, next) {
    if(window.vue_unsaved_changes){
      this.$store.state.unsaved_changes_alert_show = true
      this.$store.state.unsaved_changes_alert_method = next
    } else{
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    if(window.vue_unsaved_changes){
      this.$store.state.unsaved_changes_alert_show = true
      this.$store.state.unsaved_changes_alert_method = next
    } else{
      next()
    }
  }
}
